import React, { useState, useEffect } from "react";
import DashboardNav from "./dashboardNav";
import { useParams, useNavigate } from "react-router-dom";
import { PACKAGES } from "./TravelPackagesData";
import classes from "./TravelPackages.module.css";
import { Modal, ModalBody } from "react-bootstrap";
import Confirm from "./ConfirmModal/Confirm";
import LoginServices from "../../services/LoginServices";

const TravelPackageDetails = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [packageData, setPackageData] = useState<any>(null);
    const [numberOfPersons, setNumberOfPersons] = useState(1);
    
    // Booking States
    const [showGatewayModal, setShowGatewayModal] = useState(false);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [PaymentGateWay, setPaymentGateWay] = useState<any>("");
    const [PayableAmount, setPayableAmount] = useState(0);
    const [commissionPercentage, setCommissionPercentage] = useState(0);
    const [spin, setSpin] = useState(false);
    
    const [AllGateways, setAllGateways] = useState({
        isRazorPayPGAvailable: 1,
        isCashfreeEduAvailable: 0,
        isCashFreeAvailable: 0,
        isZwitchAvailable: 0,
        isCashfreeFastAvailable: 0,
    });

    useEffect(() => {
        let config = {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
        };
        LoginServices.getGatewayStatus(config)
            .then((response: any) => {
                if (response.data.Status == 1) {
                    setAllGateways({
                        isCashFreeAvailable: response?.data?.isCashFreeAvailable,
                        isCashfreeEduAvailable: response?.data?.isCashfreeEduAvailable,
                        isRazorPayPGAvailable: response?.data?.isRazorPayPGAvailable,
                        isZwitchAvailable: response?.data?.isZwitchAvailable,
                        isCashfreeFastAvailable: response?.data?.isCashfreeFastAvailable,
                    });
                }
            })
            .catch((e: Error) => {
                console.log(e);
            });
    }, []);

    useEffect(() => {
        const found = PACKAGES.find(p => p.id === id);
        if (found) {
            setPackageData(found);
        } else {
            navigate("/dashboard/travel-packages");
        }
    }, [id, navigate]);

    const handleBookFromDetails = () => {
        setPaymentGateWay("");
        setShowGatewayModal(true);
    };

    const handleProceedToConfirm = (e: React.FormEvent) => {
        e.preventDefault();
        if (!PaymentGateWay) {
            alert("Please select a payment gateway.");
            return;
        }

        let Commission =
            PaymentGateWay == 1
                ? 2.0 // RazorPayPercentage
                : PaymentGateWay == 2
                ? 1.5 // CashfreeUtilityPercentage
                : PaymentGateWay == 3
                ? 1.2 // CashfreeEduPercentage
                : PaymentGateWay == 4
                ? 1.8 // CashfreefastPercentage
                : 2.5; // ZwitchPercentage

        setCommissionPercentage(Commission);
        let baseAmount = Number(packageData.price) * numberOfPersons;
        setPayableAmount(
            Math.ceil(
                (baseAmount * (Commission / 100) + baseAmount) * 100
            ) / 100
        );
        
        setShowGatewayModal(false);
        setShowConfirmModal(true);
    };

    if (!packageData) return <div>Loading...</div>;

    return (
        <div className="main-section">
            <DashboardNav />
            <div className="component-container">
                <button onClick={() => navigate(-1)} style={{ marginBottom: '20px', background: 'transparent', border: 'none', cursor: 'pointer', fontWeight: 'bold' }}>
                    &larr; Back to Packages
                </button>
                <div className={classes.detailsModalContainer} style={{ height: 'auto', overflowY: 'visible' }}>
                    <div className={classes.detailsHero} style={{ backgroundImage: `url(${packageData.image})` }}>
                        <div className={classes.detailsHeroOverlay}>
                            <h2>{packageData.title}</h2>
                            <p>{packageData.nights} Nights / {packageData.nights + 1} Days</p>
                        </div>
                    </div>
                    
                    <div className={classes.detailsContent}>
                        <div className={classes.detailsLeft}>
                            <div className={classes.detailsSection}>
                                <h3>About this package</h3>
                                <p>{packageData.description}</p>
                            </div>
                            
                            <div className={classes.detailsSection}>
                                <h3>Highlights</h3>
                                <ul className={classes.highlightsList}>
                                    {packageData.highlights?.map((h: string, i: number) => (
                                        <li key={i}>{h}</li>
                                    ))}
                                </ul>
                            </div>

                            <div className={classes.detailsSection}>
                                <h3>Inclusions</h3>
                                <ul className={classes.inclusionsList}>
                                    {packageData.inclusions?.map((inc: string, i: number) => (
                                        <li key={i}>{inc}</li>
                                    ))}
                                </ul>
                            </div>

                            <div className={classes.detailsSection}>
                                <h3>Itinerary</h3>
                                <div className={classes.itineraryTimeline}>
                                    {packageData.itinerary?.map((day: any, i: number) => (
                                        <div key={i} className={classes.itineraryItem}>
                                            <div className={classes.itineraryDay}>Day {day.day}</div>
                                            <div className={classes.itineraryDetails}>
                                                <h4>{day.title}</h4>
                                                <p>{day.description}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        
                        <div className={classes.detailsRight}>
                            <div className={classes.bookingCard}>
                                <h3>Book Package</h3>
                                <div className={classes.priceRow}>
                                    <span className={classes.priceLabel}>Price per person</span>
                                    <span className={classes.priceVal}>₹{packageData.price.toLocaleString('en-IN')}</span>
                                </div>
                                
                                <div className={classes.personsControl}>
                                    <label>Number of Persons</label>
                                    <div className={classes.counterBox}>
                                        <button type="button" onClick={() => setNumberOfPersons(p => Math.max(1, p - 1))}>-</button>
                                        <span>{numberOfPersons}</span>
                                        <button type="button" onClick={() => setNumberOfPersons(p => p + 1)}>+</button>
                                    </div>
                                </div>
                                
                                <div className={classes.totalPriceRow}>
                                    <span className={classes.totalLabel}>Total Base Price</span>
                                    <span className={classes.totalVal}>₹{(packageData.price * numberOfPersons).toLocaleString('en-IN')}</span>
                                </div>
                                
                                <button className={classes.bookActionBtn} onClick={handleBookFromDetails}>
                                    PROCEED TO BOOK
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Gateway Modal */}
            <Modal show={showGatewayModal} onHide={() => setShowGatewayModal(false)} centered>
                <ModalBody>
                    <div style={{ padding: '20px' }}>
                        <h4 style={{ marginBottom: '20px', fontWeight: 'bold' }}>Select Payment Gateway</h4>
                        <p style={{ marginBottom: '5px' }}>Booking: <strong>{packageData?.title}</strong></p>
                        <p style={{ marginBottom: '20px' }}>Persons: <strong>{numberOfPersons}</strong></p>
                        <p style={{ marginBottom: '20px', fontSize: '18px' }}>Total Amount: <strong>₹{(packageData?.price * numberOfPersons).toLocaleString('en-IN')}</strong></p>
                        
                        <form onSubmit={handleProceedToConfirm}>
                            <div className="drop-down amount-data" style={{ marginBottom: '20px' }}>
                                <label style={{ display: 'block', marginBottom: '8px', fontWeight: 600 }}>Payment Gateway</label>
                                <select 
                                    className="form-control" 
                                    value={PaymentGateWay} 
                                    onChange={(e) => setPaymentGateWay(e.target.value)}
                                    style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc', appearance: 'auto', backgroundColor: '#fff' }}
                                >
                                    <option value="">Select Payment Gateway</option>
                                    <option value={2} disabled={AllGateways?.isCashFreeAvailable == 0}>
                                        Cashfree Utility (1.5%)
                                    </option>
                                    {localStorage.getItem("userid") != "1111111" && (
                                        <option value={3} disabled={AllGateways?.isCashfreeEduAvailable == 0}>
                                            Cashfree Edu (1.2%)
                                        </option>
                                    )}
                                    <option value={1} disabled={AllGateways?.isRazorPayPGAvailable == 0}>
                                        Razor Pay (2.0%)
                                    </option>
                                    <option value={4} disabled={AllGateways?.isCashfreeFastAvailable == 0}>
                                        Cashfree Fast (1.8%)
                                    </option>
                                    <option value={5} disabled={AllGateways?.isZwitchAvailable == 0}>
                                        Zwitch (2.5%)
                                    </option>
                                </select>
                            </div>
                            
                            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                                <button type="button" onClick={() => setShowGatewayModal(false)} style={{ padding: '10px 20px', borderRadius: '4px', border: '1px solid #ccc', background: 'white' }}>
                                    Cancel
                                </button>
                                <button type="submit" style={{ padding: '10px 20px', borderRadius: '4px', border: 'none', background: '#e76f51', color: 'white', fontWeight: 'bold' }}>
                                    Proceed to Pay
                                </button>
                            </div>
                        </form>
                    </div>
                </ModalBody>
            </Modal>

            {/* Confirm Modal */}
            {showConfirmModal && (
                <Confirm
                    submitenabler={spin}
                    commissionPercentage={commissionPercentage}
                    setSpinner={setSpin}
                    payHandler={() => {}}
                    passBlc={packageData?.price * numberOfPersons}
                    apidatasend={{ packageId: packageData?.id, persons: numberOfPersons }}
                    commissionamount={PayableAmount}
                    show={showConfirmModal}
                    PaymentGateWay={PaymentGateWay}
                    onHide={() => setShowConfirmModal(false)}
                />
            )}
        </div>
    );
};

export default TravelPackageDetails;
